import React from 'react';
import {Link } from 'react-router-dom';

const FeaturedEvent = () => {
  return (
    <section id="events" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-outfit font-800 text-white mb-4 text-center">
          Current Edition
        </h2>
        
        <div className="w-24 h-1 bg-crimson mx-auto mb-16"></div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-900 border-2 border-crimson rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300">
            <div className="relative h-80 overflow-hidden">
              <img 
                src="/images/backgrounds/GITAM_Hyderabad_Campus.jpg" 
                alt="AI Day @ GITAM University" 
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute top-4 left-4 bg-crimson px-4 py-2 rounded">
                <p className="text-white font-outfit font-800 text-sm uppercase">FEATURED EVENT</p>
              </div>
            </div>
            
            <div className="p-8 bg-gray-900">
              <h3 className="text-2xl md:text-3xl font-outfit font-800 text-white mb-6 bg-gray-800 p-4 rounded border-l-4 border-crimson">
                AI Day @ GITAM University
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-crimson rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-500 font-outfit font-600 text-sm">Date</p>
                    <p className="text-white font-outfit font-800 text-lg">5 – 6 March 2026</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-crimson rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-500 font-outfit font-600 text-sm">Location</p>
                    <p className="text-white font-outfit font-800 text-lg">Hyderabad</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:col-span-2">
                  <div className="w-10 h-10 bg-crimson rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-500 font-outfit font-600 text-sm">Tracks</p>
                    <p className="text-white font-outfit font-800 text-lg">Hackathon · Use Cases · Demos</p>
                  </div>
                </div>
              </div>

              <Link to="/events/gitam-university" className="btn-primary w-full inline-block text-center">
                View Event Page
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedEvent;
